<template>
  <div class="popularity">
    <div class="popularity__layout">
      <div ref="tinySlider" class="popularity__compared">
        <div class="popularity__compared-group" v-for="(item, index) in popularity" :key="item[0].description" :title="item[0].description">
          <div class="popularity__compared-label">{{ item[0].name }} {{ item[0].comparable | vs }} {{ item[1].name }}</div>
          <PopularityAvatars
            :index="index"
            :description="item[0].description"
          />
          <PopularityTable
            :groupData="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/src/tiny-slider.scss'
import POPULARITY from '@/data/popularity'
import PopularityAvatars from '@/components/PopularityAvatars.vue'
import PopularityTable from '@/components/PopularityTable.vue'

export default {
  name: 'Popularity',
  data () {
    return {
      popularity: POPULARITY,
      popularityLength: 0,
      slider: null
    }
  },
  components: {
    PopularityAvatars,
    PopularityTable
  },
  filters: {
    vs (isComparable) {
      return !isComparable ? '&' : 'VS'
    }
  },
  methods: {
    onSliderIndexChanged (event, eventName) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Slide',
        'eventLabel': `Air-Fight-${event.displayIndex}`
      })
    }
  },
  mounted () {
    this.slider = tns({
      container: this.$refs.tinySlider,
      items: 1,
      center: true,
      loop: true,
      edgePadding: 20,
      mouseDrag: true,
      swipeAngle: 25,
      speed: 400,
      controls: true,
      nav: false,
      autoHeight: true,
      // lazyload: true,
      // lazyloadSelector: '.popularity-avatars__image',
      preventScrollOnTouch: 'auto',
      responsive: {
        '520': {
          edgePadding: 35
        },
        '760': {
          edgePadding: 125
        },
        '960': {
          edgePadding: 45
        },
        '1280': {
          edgePadding: 206
        }
      }
    })

    this.slider.events.on('indexChanged', this.onSliderIndexChanged)

    this.$ga('newmedia.send', {
      'hitType': 'event',
      'eventCategory': 'Read',
      'eventAction': 'Slide',
      'eventLabel': 'Air-Fight-1'
    })

    this.popularityLength = this.popularity.length
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .popularity {
    &__layout {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
      user-select: none;
    }

    &__layout:before, &__layout:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      height: 100%;
      z-index: 1;
      background: linear-gradient(to right, rgba(245, 198, 184, 1) 0, rgba(245,198,184,1) 30%, rgba(245,198,184,0) 100%);
    }

    &__layout:after {
      left: auto;
      right: 0;
      background: linear-gradient(to left, rgba(245,198,184,1) 0, rgba(245,198,184,1) 30%, rgba(245,198,184,0) 100%);
    }

    @include rwd($RWD_TABLET_SMALL) {
      &__layout:before, &__layout:after {
        width: 30px;
        background: linear-gradient(to right, rgba(245, 198, 184, 1) 50%, rgba(245,198,184,0.8) 60%, rgba(245,198,184,0) 100%);
      }

      &__layout:after {
        background: linear-gradient(to left, rgba(245,198,184,1) 50%, rgba(245,198,184,0.8) 60%, rgba(245,198,184,0) 100%);
      }
    }

    @include rwd($RWD_TABLET) {
      &__layout:before, &__layout:after {
        width: 150px;
        background: linear-gradient(to right, rgba(245, 198, 184, 1) 30%, rgba(245,198,184,0.8) 40%, rgba(245,198,184,0) 100%);
      }

      &__layout:after {
        background: linear-gradient(to left, rgba(245,198,184,1) 30%, rgba(245,198,184,0.8) 40%, rgba(245,198,184,0) 100%);
      }
    }

    @include rwd($RWD_DESKTOP) {
      &__layout:before, &__layout:after {
        width: 100px;
        background: linear-gradient(to right, rgba(245, 198, 184, 1) 0, rgba(245,198,184,0.4) 40%, rgba(245,198,184,0) 100%);
      }

      &__layout:after {
        background: linear-gradient(to left, rgba(245,198,184,1) 0, rgba(245,198,184,0.4) 40%, rgba(245,198,184,0) 100%);
      }
    }

    @include rwd($RWD_DESKTOP_WIDE) {
      &__layout:before, &__layout:after {
        width: 15%;
        background: linear-gradient(to right, rgba(245, 198, 184, 1) 0, rgba(245, 198, 184, 0.95) 60%, rgba(245,198,184,0) 100%);
      }

      &__layout:after {
        background: linear-gradient(to left, rgba(245,198,184,1) 0, rgba(245, 198, 184, 0.95) 60%, rgba(245,198,184,0) 100%);
      }
    }

    &__compared {
      backface-visibility: hidden;
      will-change: transform;
    }

    &__compared-group {
      padding: 0 3px;
      cursor: grab;

      &:active {
        cursor: grabbing;
      }

      @include rwd($RWD_TABLET_SMALL) {
        padding: 0 9px;
      }

      @include rwd($RWD_DESKTOP) {
        padding: 0 15px;
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        padding: 0 17px;
      }
    }

    &__compared-label {
      margin-bottom: 16px;
      font-size: 1.125em;
      letter-spacing: 0.1em;
      font-family: 'Noto Serif TC';
      font-weight: 600;
      text-align: center;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.5rem;
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.375rem;
      }
    }

    .tns-controls {
      @include use-layer(&);
      position: absolute;
      top: 22%;
      left: 0;
      margin-top: -20px;
      width: 100%;
      height: 0;

      &:focus {
        outline: none;
      }

      button {
        position: absolute;
        display: inline-block;
        left: 0;
        width: 40px;
        height: 40px;
        font-size: 0;
        background: transparent;
        border: transparent;
        background: #7e93ce url(~@/assets/arrow-down.svg) no-repeat center 60%;
        background-size: 50%;
        transform: rotate(90deg);
      }

      button + button {
        left: auto;
        right: 0;
        transform: rotate(-90deg);
      }

      @include rwd($RWD_TABLET_SMALL) {
        top: 28%;

        button {
          width: 50px;
          height: 50px;
          background-size: 40%;
        }
      }

      @include rwd($RWD_TABLET) {
        button {
          left: 125 + 6 - 37px;
          background: #7e93ce url(~@/assets/arrow-down.svg) no-repeat center 55%;
          background-size: 40%;
        }

        button + button {
          right: 125 + 6 - 37px;
        }
      }

      @include rwd($RWD_DESKTOP) {
        button {
          width: 72px;
          height: 72px;
          left: 17px;
          background-size: 36%;
        }

        button + button {
          right: 17px;
        }
      }

      @include rwd($RWD_DESKTOP_WIDE) {
        top: 33%;
        button {
          left: 14%;
        }

        button + button {
          right: 14%;
        }
      }
    }
  }
</style>
